import { userDate } from 'owa-datetime';
import { formatUserDate, formatUserDateTime } from 'owa-datetime-formatters';

/**
 * Formats a flag due date ISO string to a user-friendly date string.
 * @param flagDueDate - ISO date string like "2026-02-06T00:00:00-06:00"
 * @returns Formatted date string like "2/6/2026" or "2/6/2026 11:59 PM" (based on user's locale and available width)
 */
export default function formatFlagDueDate(
    flagDueDate: string | null | undefined,
    flagDueDateColumnWidth: number
): string {
    if (!flagDueDate) {
        return '--';
    }
    if (flagDueDateColumnWidth < 104) {
        return formatUserDate(userDate(flagDueDate));
    }
    return formatUserDateTime(userDate(flagDueDate));
}
